import React from "react";

const Radio = (props) => {

    const { height, width, onClick, active, id="" } = props;

    return (
        <>
            {

                active ?
                    <svg id={`radio-active-${id}`}  width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><circle cx="40" cy="40" r="40" className="mixer-radio-bg-active"></circle><circle cx="40" cy="40" r="20" className="mixer-radio-val-active"></circle></svg>
                    : <svg id={`radio-inactive-${id}`} width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><circle cx="40" cy="40" r="40" className="mixer-radio-bg-inactive"></circle><circle cx="40" cy="40" r="20" className="mixer-radio-val-inactive"></circle></svg>
            }
        </>
    )
}

Radio.defaultProps = {
    height: 30,
    width: 30
}

export default Radio;